import { createFileRoute } from '@tanstack/react-router'

import StateFilingsLandingPage from '@/features/state-filings/pages/landing'

export const Route = createFileRoute('/_shell/state-filings/')({ component: StateFilingsLandingPage })
